import './styles.css';

type ScrapeResponse = {
  url: string;
  status: number;
  contentType: string | null;
  fetchedAt: string;
  title: string | null;
  ogTitle: string | null;
  description: string | null;
  ogDescription: string | null;
};

type ErrorResponse = {
  error: string;
  status?: number;
};

const form = document.getElementById('scrape-form') as HTMLFormElement | null;
const result = document.getElementById('result');

if (form && result) {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const data = new FormData(form);
    const urlToScrape = (data.get('target-url') ?? '').toString().trim();

    if (!urlToScrape) {
      renderError('Please provide a URL to scrape.');
      return;
    }

    renderLoading();

    try {
      const query = new URLSearchParams({ url: urlToScrape });
      const response = await fetch(`/api/scrape?${query.toString()}`);
      const payload: ScrapeResponse | ErrorResponse = await response.json();

      if (!response.ok) {
        const message = 'error' in payload ? payload.error : 'Scrape failed.';
        renderError(message, response.status);
        return;
      }

      renderSuccess(payload as ScrapeResponse);
    } catch (error) {
      console.error('Failed to call /api/scrape', error);
      renderError('Unable to reach the scraping endpoint.');
    }
  });
}

function renderLoading() {
  if (!result) return;
  result.innerHTML = `<p class="status">Loading…</p>`;
}

function renderError(message: string, status?: number) {
  if (!result) return;
  const label = status ? `Error ${status}: ` : '';
  result.innerHTML = `<p class="status error">${label}${escapeHtml(message)}</p>`;
}

function renderSuccess(data: ScrapeResponse) {
  if (!result) return;
  const formatted = escapeHtml(JSON.stringify(data, null, 2));
  result.innerHTML = [
    `<p class="status success">Fetched metadata from ${escapeHtml(data.url)}</p>`,
    `<pre>${formatted}</pre>`,
  ].join('\n');
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
